const Report = () =>
  import(
    /* webpackChunkName: "external-baraneh" */ '@/pages/external/baraneh/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "external-baraneh" */ '@/pages/external/baraneh/create.vue'
  )

export default {
  name: 'Baraneh',
  path: 'baraneh',
  meta: {
    label: 'baraneh',
    auth: 'baraneh'
  },
  component: {
    name: 'Baraneh',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaranehReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'CreateBaraneh',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    }
  ]
}
